'use client';

import { useStore } from '@/store/store';
import { useRealityCheck } from '@/hooks/use-reality-check/use-reality-check';
import { NotificationBox } from '@/app/components/notification-box/notification-box';
import { getText } from '@/utils/text/text';
import { buildAccountUrl } from '@/utils/url/account';
import { timeToString } from '@/utils/reality-check/time-to-string';
import { formatAmount } from '@/utils/reality-check/format-amount';

import './styles/@theme';

export const RealityCheckPopup = () => {
    const region = useStore((state) => state.globals.region);
    const { handleContinue } = useRealityCheck();
    const { isModalVisible, playedTime, profitAndLoss } = useStore((state) => state.realityCheck);
    const getCurrencySymbol = useStore((state) => state.getCurrencySymbol);

    if (!isModalVisible) {
        return null;
    }

    const formattedAmount = formatAmount(profitAndLoss);
    const formattedTime = timeToString(playedTime);
    const editUrl = buildAccountUrl('/reality-check', region);

    const formatDate = (date = new Date()) => {
        const formatted = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        }).format(date);

        return formatted.replace(',', '');
    };

    return (
        <div>
            <NotificationBox
                title={getText({ text: 'components.xgames.notifications.realityCheck.title' })}
                buttonText={getText({ text: 'components.xgames.notifications.realityCheck.gotIt' })}
                onButtonClick={handleContinue}
                linkText={getText({ text: 'components.xgames.notifications.realityCheck.edit' })}
                linkHref={editUrl}>
                <p className="wagered">
                    You have wagered{' '}
                    <span>
                        {getCurrencySymbol()}
                        {formattedAmount}
                    </span>{' '}
                    in the last <span>{formattedTime}</span>.
                </p>
                <p className="note">{getText({ text: 'components.xgames.notifications.realityCheck.note' })}</p>
                <p className="time">
                    {getText({ text: 'components.xgames.notifications.realityCheck.time' }) + formatDate()}
                </p>
            </NotificationBox>
        </div>
    );
};
